import { useRef, useState } from "react";
import { validateEmail } from "../utils/HelperFunctions";
import { FormData } from "../utils/interfaces";
import toast, { Toaster } from "react-hot-toast";
import emailjs from "@emailjs/browser";
import { Select, Textarea, TextInput } from "@mantine/core";
import { technologiesOptions } from "../utils/constants";
import { motion } from "framer-motion";
import { FiArrowRight } from "react-icons/fi";

const initialFormState = {
  username: "",
  email: "",
  phone: "",
  message: "",
  technology: null,
};


const ContactForm = () => {
  const [formData, setFormData] = useState<FormData>(initialFormState);
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const form = useRef<HTMLFormElement>(null);

  const handleInput = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear error when user starts typing
    setFormErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handleSelectChange = (value: string | null) => {
    if (!value) {
      setFormErrors({ ...formErrors, technology: "Please select technology" });
      setFormData({ ...formData, technology: "" })
    } else {
      setFormErrors({ ...formErrors, technology: "" });
      setFormData({ ...formData, technology: value as string });
    }
  }

  console.log(formData,'@@@formData')

  const validateForm = () => {
    const errors: Record<string, string> = {};

    if (!formData?.username?.trim()) errors.username = "Name is required";
    if (!formData?.email?.trim() || !validateEmail(formData?.email))
      errors.email = "Valid email is required";
    if (!formData?.phone) errors.phone = "Phone number is required";
    if (!formData?.message?.trim()) errors.message = "Message cannot be empty";
    if (!formData?.technology) errors.technology = "Please select technology";
    setFormErrors(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  };

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!validateForm()) {
      toast.error("Please fill all required fields correctly.");
      return;
    }

    try {
      sendEmail(e);
      setFormData(initialFormState);
      setFormErrors({});
      toast.success("Message sent successfully!");
    } catch (err) {
      toast.error("There is some error, please try again later.");
    }
  };

  const sendEmail = (e: any) => {
    e.preventDefault();
    const SERVICE_KEY = "service_99hiczf";
    const PUBLIC_KEY = "Q9b_snzRQTN318hjZ";
    const TEMPLATE_ID = "template_kzm17wr";

    emailjs.sendForm(SERVICE_KEY, TEMPLATE_ID, form.current!, PUBLIC_KEY).then(
      (result) => {
        console.log(result.text);
      },
      (error) => {
        console.log(error.text);
      }
    );
  };

  return (
    <form
      autoComplete="off"
      onSubmit={handleFormSubmit}
      method="post"
      ref={form}
      className="w-full"
    >
      <Toaster />
      <div className="gap-4 500:gap-5 flex flex-col w-full">
        <div className="grid grid-cols-1 500:grid-cols-2 gap-4 500:gap-5">
          <div>
            <TextInput
              label={
                <span className="text-neutral-300 font-poppins-medium text-sm mb-1 block">
                  Name <span className="text-primary-400">*</span>
                </span>
              }
              type="text"
              name="username"
              placeholder="Your name"
              onChange={handleInput}
              value={formData.username}
              error={formErrors.username}
              classNames={{
                input: "bg-neutral-900/50 border-neutral-700/50 text-neutral-100 placeholder:text-neutral-500 focus:border-primary-500 focus:bg-neutral-900/70 font-poppins-regular",
                label: "text-neutral-300",
                error: "text-red-400 text-xs mt-1",
              }}
              styles={{
                input: {
                  backgroundColor: "rgba(17, 24, 39, 0.5)",
                  borderColor: "rgba(55, 65, 81, 0.5)",
                  color: "#f3f4f6",
                  fontFamily: "Poppins, system-ui, sans-serif",
                },
              }}
            />
          </div>
          <div>
            <TextInput
              label={
                <span className="text-neutral-300 font-poppins-medium text-sm mb-1 block">
                  Email Address <span className="text-primary-400">*</span>
                </span>
              }
              type="email"
              name="email"
              placeholder="your.email@example.com"
              onChange={handleInput}
              value={formData.email}
              error={formErrors.email}
              classNames={{
                input: "bg-neutral-900/50 border-neutral-700/50 text-neutral-100 placeholder:text-neutral-500 focus:border-primary-500 focus:bg-neutral-900/70 font-poppins-regular",
                label: "text-neutral-300",
                error: "text-red-400 text-xs mt-1",
              }}
              styles={{
                input: {
                  backgroundColor: "rgba(17, 24, 39, 0.5)",
                  borderColor: "rgba(55, 65, 81, 0.5)",
                  color: "#f3f4f6",
                  fontFamily: "Poppins, system-ui, sans-serif",
                },
              }}
            />
          </div>
        </div>
        <div className="grid grid-cols-1 500:grid-cols-2 gap-4 500:gap-5">
          <div>
            <TextInput
              label={
                <span className="text-neutral-300 font-poppins-medium text-sm mb-1 block">
                  Phone Number <span className="text-primary-400">*</span>
                </span>
              }
              type="tel"
              name="phone"
              placeholder="+1 234 567 8900"
              onChange={handleInput}
              value={formData.phone}
              error={formErrors.phone}
              classNames={{
                input: "bg-neutral-900/50 border-neutral-700/50 text-neutral-100 placeholder:text-neutral-500 focus:border-primary-500 focus:bg-neutral-900/70 font-poppins-regular",
                label: "text-neutral-300",
                error: "text-red-400 text-xs mt-1",
              }}
              styles={{
                input: {
                  backgroundColor: "rgba(17, 24, 39, 0.5)",
                  borderColor: "rgba(55, 65, 81, 0.5)",
                  color: "#f3f4f6",
                  fontFamily: "Poppins, system-ui, sans-serif",
                },
              }}
            />
          </div>
          <div>
            <Select
              label={
                <span className="text-neutral-300 font-poppins-medium text-sm mb-1 block">
                  Technology <span className="text-primary-400">*</span>
                </span>
              }
              placeholder="Select technology"
              value={formData.technology}
              onChange={(e) => handleSelectChange(e)}
              error={formErrors.technology}
              data={technologiesOptions}
              classNames={{
                input: "bg-neutral-900/50 border-neutral-700/50 text-neutral-100 focus:border-primary-500 focus:bg-neutral-900/70 font-poppins-regular",
                label: "text-neutral-300",
                error: "text-red-400 text-xs mt-1",
              }}
              styles={{
                input: {
                  backgroundColor: "rgba(17, 24, 39, 0.5)",
                  borderColor: "rgba(55, 65, 81, 0.5)",
                  color: "#f3f4f6",
                  fontFamily: "Poppins, system-ui, sans-serif",
                },
              }}
            />
          </div>
        </div>
        <div>
          <Textarea
            label={
              <span className="text-neutral-300 font-poppins-medium text-sm mb-1 block">
                Your Message <span className="text-primary-400">*</span>
              </span>
            }
            placeholder="Tell us about your project..."
            autosize
            name="message"
            onChange={handleInput}
            value={formData.message}
            minRows={5}
            error={formErrors.message}
            classNames={{
              input: "bg-neutral-900/50 border-neutral-700/50 text-neutral-100 placeholder:text-neutral-500 focus:border-primary-500 focus:bg-neutral-900/70",
              label: "text-neutral-300",
              error: "text-red-400 text-xs mt-1",
            }}
            styles={{
              input: {
                backgroundColor: "rgba(17, 24, 39, 0.5)",
                borderColor: "rgba(55, 65, 81, 0.5)",
                color: "#f3f4f6",
              },
            }}
          />
        </div>
      </div>
      
      <p className="text-xs 500:text-sm font-poppins-regular text-neutral-400 pt-4">
        By proceeding, you are agreeing to Nexasoft{" "}
        <span className="text-primary-400 hover:text-primary-300 cursor-pointer">Privacy Policy</span> & communication
      </p>

      <motion.button
        type="submit"
        className="w-full bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white text-base 500:text-lg py-3 500:py-4 font-poppins-semi-bold rounded-xl mt-6 shadow-lg hover:shadow-xl hover:shadow-primary-500/30 transition-all duration-300 flex items-center justify-center gap-2 group"
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
      >
        <span>Send Enquiry</span>
        <motion.div
          initial={{ x: 0 }}
          whileHover={{ x: 5 }}
          transition={{ duration: 0.3 }}
        >
          <FiArrowRight className="w-5 h-5" />
        </motion.div>
      </motion.button>
    </form>
  );
};

export default ContactForm;
